import { ref, watch } from "vue";
import { useNgSession } from "@sazka/ng/ng-session";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { useLocalStorage } from "@sazka/utils/use-storage";

const cookieName = "isLoyaltyStickerCollapsed";

const store = useLocalStorage();

const isFixedHelpCollapsed = ref(store.getItem(cookieName) === "true");
const isLoyaltyStickerCollapsed = ref(true);

const isTablet = useBreakpoints("sm");

watch(
    isTablet,
    (newIsTablet) => {
        if (!newIsTablet && !isLoyaltyStickerCollapsed.value && !isFixedHelpCollapsed.value) {
            isLoyaltyStickerCollapsed.value = true;
        }
    },
    {
        immediate: true,
    }
);

watch(isLoyaltyStickerCollapsed, (newIsLoyaltyStickerCollapsed) => {
    if (!newIsLoyaltyStickerCollapsed && !isTablet.value) {
        isFixedHelpCollapsed.value = true;
    }
});

watch(isFixedHelpCollapsed, (newIsFixedHelpCollapsed) => {
    store.setItem(cookieName, newIsFixedHelpCollapsed ? "true" : null, "essential");

    if (!newIsFixedHelpCollapsed && !isTablet.value) {
        isLoyaltyStickerCollapsed.value = true;
    }
});

const { isLoggedIn } = useNgSession();
watch(isLoggedIn, (newIsLoggedIn) => {
    if (!newIsLoggedIn) {
        isLoyaltyStickerCollapsed.value = true;
    }
});

export const useStickersState = () => {
    return {
        isLoyaltyStickerCollapsed,
        isFixedHelpCollapsed,
    };
};
